import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Card } from 'react-bootstrap';

interface Post {
  id: number;
  title: string;
  content: string;
  date: string;
}

const PostDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [post, setPost] = useState<Post | null>(null);

  useEffect(() => {
    // Simulating an API request or using mock data
    const fetchedPost = {
      id: parseInt(id || '0'),
      title: `Post ${id}`,
      content: 'This is the full content of the post...',
      date: '2025-02-17',
    };
    setPost(fetchedPost);
  }, [id]);

  if (!post) return <div>Loading...</div>;

  return (
    <Container>
      <Card>
        <Card.Body>
          <Card.Title>{post.title}</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">{post.date}</Card.Subtitle>
          <Card.Text>{post.content}</Card.Text>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PostDetail;
